/* eslint-disable */
export default {
  ringtones: 'Tonos',
  incomingRingtone: 'Tono entrante',
  outgoingRingtone: 'Tono saliente',
  play: 'Reproducir',
  stop: 'Detener',
  upload: 'Cargar',
  reset: 'Restablecer',
  save: 'Guardar',
} as const;

// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"incomingRingtone"@#@ @source: @#@"Incoming Ringtone"@#@
// @key: @#@"outgoingRingtone"@#@ @source: @#@"Outgoing Ringtone"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"stop"@#@ @source: @#@"Stop"@#@
// @key: @#@"upload"@#@ @source: @#@"Upload"@#@
// @key: @#@"reset"@#@ @source: @#@"Reset"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
